/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-scroll-to-top[_ngcontent-%COMP%]{display:block;position:fixed;bottom:10px;right:-100px;opacity:0;transition:all .5s}@media (min-width:768px){.nsc-scroll-to-top[_ngcontent-%COMP%]{display:none}}.nsc-scroll-to-top--visible[_ngcontent-%COMP%]{right:10px;opacity:1}"];
export { styles as styles };
